import { render, staticRenderFns } from "./ModalLpfrAdditionalInfo.vue?vue&type=template&id=ee12cfb8&scoped=true&"
import script from "./ModalLpfrAdditionalInfo.vue?vue&type=script&lang=js&"
export * from "./ModalLpfrAdditionalInfo.vue?vue&type=script&lang=js&"
import style0 from "./ModalLpfrAdditionalInfo.vue?vue&type=style&index=0&id=ee12cfb8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee12cfb8",
  null
  
)

export default component.exports